import React from 'react';
import PageContainer from 'components/PageContainer';
import PageContent from 'components/PageContent';
import AmlTable from './AmlTable';
import { useGetRole } from 'hooks/ui/useGetRole';

const breadcrumbs = [
  { label: 'Dashboard' },
  { label: 'Investor', link: '/investor' },
  { label: 'Ongoing AML Review', link: '/', isActive: true },
];

const OngoingAml: React.FC = () => {
  const { isSuperAdmin } = useGetRole();

  return (
    <PageContainer heading="Ongoing AML Review" breadcrumbs={breadcrumbs}>
      <PageContent>
        <AmlTable isSuperAdmin={isSuperAdmin} />
      </PageContent>
    </PageContainer>
  );
};

export default OngoingAml;
